import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as KubitBrandmark } from '../../assets/images/kubit-brandmark.svg';
import { ReactComponent as KubitWordmark } from '../../assets/images/kubit-wordmark.svg';
import { theme } from '../../styles/theme';
import { getScrollBarStyles } from '../../config/styles';

interface IProps {
  children: ReactNode;
  heading: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 100%;
  max-height: 100%;
  padding: 48px;
  overflow-y: auto;
  ${getScrollBarStyles(2)};
`;
const LogoContainer = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  column-gap: 10px;
  color: #292d48;

  body.dark & {
    color: ${theme.colors.white};
  }
`;
const ContentWrapper = styled.div`
  width: 540px;
  max-width: 100%;
  margin: auto;
  padding: 24px;
  border-radius: 4px;
  background-color: ${theme.colors.level2};
`;
const Heading = styled.h1`
  margin: 0 0 32px 0;
  font: inherit;
  font-size: 32px;
  font-weight: 400;
  line-height: 44px;
  color: ${theme.colors.secondary900};
`;

const AuthLayout = ({ children, heading }: IProps) => {
  return (
    <Container>
      <LogoContainer>
        <KubitBrandmark fill="currentColor" />
        <KubitWordmark width={107} height={32} fill="currentColor" />
      </LogoContainer>

      <ContentWrapper>
        <Heading>{heading}</Heading>
        {children}
      </ContentWrapper>
    </Container>
  );
};

export default AuthLayout;
